<template>
  <section class="featured-section">
    <div class="featured-bg"></div>
    <div class="featured-box">
      <div class="text-box">
        <div class="top-meta">
          <h3>Durante a fase online, como se dará a prevenção de hackers?</h3>
        </div>
        <p>
          O match maker dos jogos na fase online se dará através da
          <a target="_blank" href="https://gamersclub.com.br/">Gamers Club</a>
          (GC). A GC possui uma forte política contra hackers e seu louncher
          contém um anti-cheat integrado que detecta e faz o banimento dos
          jogadores que estiverem fazendo uso de hacks.
        </p>
        <p>
          Ficou com dúvida quanto a performance do outro time? Ao final da
          partida você pode denunciar e a equipe realizadora do evento irá
          analisar. Constatada a irregularidade a punição é o
          <strong>banimento</strong> da equipe beneficiada da competição e
          anulação da partida.
        </p>
        <p>
          NÃO SERÃO ADMITIDOS AUXÍLIOS EXTERNOS DE NENHUM MODO. A CIES NÃO
          INCENTIVA A DESPORTIVIDADE. JOGUE LIMPO!
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.featured-box {
  padding: 50px 50px 50px 75px;
}

.text-box {
  margin: 0 !important;
}

.featured-bg {
  background-image: url("~@/assets/img/featured-bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

a {
  color: #b01ba5 !important;
}
</style>
